<div mat-dialog-title class="fx-layout-row">
  <div class="fx-layout-row fx-flex fx-align--x-center fx-align--space-between-x">
    <h2>
      Can't Rotate
    </h2>
    <button mat-icon-button mat-dialog-close tabindex="-1">
      <mat-icon svgIcon="x"></mat-icon>
    </button>
  </div>
</div>

<mat-dialog-content>
  <p>Rotating the opening and mat separately is not possible because the opening would no longer fit in the mat.</p>

  <mbnm-project-preview [project]="project" [showRotationRestrictions]="true">
  </mbnm-project-preview>

</mat-dialog-content>

<mat-dialog-actions class="fx-layout-row fx-align--space-between-x">

  <button mat-flat-button color="primary" [mat-dialog-close]="true">
    Rotate Together
  </button>

  <button mat-flat-button color="secondary" [mat-dialog-close]="false">
    Cancel
  </button>
</mat-dialog-actions>


